var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-alert",
        {
          staticClass: "mb-4",
          attrs: { dense: "", text: "", type: "info", border: "left" },
        },
        [
          _vm._v(" O "),
          _c("strong", [_vm._v("valor padrão")]),
          _vm._v(
            " é o valor que cada usuário deste perfil recebe ao abrir a tela. Com a "
          ),
          _c("strong", [_vm._v("trava")]),
          _vm._v(" ativa, o usuário não pode alterar o recurso na sessão. "),
        ]
      ),
      _c("v-text-field", {
        staticClass: "mb-3",
        attrs: {
          "prepend-inner-icon": "mdi-magnify",
          label: "Buscar recurso",
          dense: "",
          outlined: "",
          clearable: "",
          "hide-details": "",
        },
        model: {
          value: _setup.search,
          callback: function ($$v) {
            _setup.search = $$v
          },
          expression: "search",
        },
      }),
      _c(
        "v-chip-group",
        {
          staticClass: "mb-3",
          attrs: { mandatory: "", column: "" },
          model: {
            value: _setup.selectedContext,
            callback: function ($$v) {
              _setup.selectedContext = $$v
            },
            expression: "selectedContext",
          },
        },
        _vm._l(_setup.contexts, function (ctx) {
          return _c(
            "v-chip",
            {
              key: ctx.key,
              attrs: {
                value: ctx.key,
                small: "",
                filter: "",
                "active-class": "primary white--text",
              },
            },
            [_vm._v(" " + _vm._s(ctx.label) + " ")]
          )
        }),
        1
      ),
      _vm._l(_setup.grouped, function (items, group) {
        return _c(
          "div",
          { key: group, staticClass: "mb-5" },
          [
            _c(
              "div",
              { staticClass: "d-flex align-center mb-2" },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "", color: "grey darken-1" },
                  },
                  [_vm._v("mdi-tune-variant")]
                ),
                _c(
                  "span",
                  { staticClass: "subtitle-2 grey--text text--darken-2" },
                  [_vm._v(_vm._s(group))]
                ),
              ],
              1
            ),
            _c(
              "v-card",
              { attrs: { outlined: "" } },
              [
                _c("div", { staticClass: "feature-row feature-head" }, [
                  _c(
                    "span",
                    { staticClass: "head-cell" },
                    [
                      _vm._v(" Valor padrão "),
                      _c("tooltips-helper", {
                        attrs: {
                          "hide-title": "",
                          color: "grey darken-1",
                          "max-width": "280px",
                          text: "Estado em que o recurso já vem ligado ou desligado quando um usuário deste perfil abre a tela. Ligado libera o recurso; desligado mantém a regra padrão do sistema.",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("span", [_vm._v("Recurso")]),
                  _c(
                    "span",
                    { staticClass: "head-cell justify-center" },
                    [
                      _vm._v(" Trava "),
                      _c("tooltips-helper", {
                        attrs: {
                          "hide-title": "",
                          color: "grey darken-1",
                          "max-width": "280px",
                          text: "Cadeado fechado impede que o usuário ligue ou desligue este recurso durante o uso da tela — ele fica sempre no valor padrão. Cadeado aberto deixa o usuário alterar quando precisar.",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("v-divider"),
                _vm._l(items, function (feature, idx) {
                  return [
                    idx > 0
                      ? _c("v-divider", { key: "d-" + feature.id })
                      : _vm._e(),
                    _c("div", { key: feature.id, staticClass: "feature-row" }, [
                      _setup.isField(feature)
                        ? _c("div", [
                            _c("div", { staticClass: "caption grey--text" }, [
                              _vm._v("Não se aplica"),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "caption grey--text text--darken-1",
                              },
                              [_vm._v("Valor do cadastro")]
                            ),
                          ])
                        : _c(
                            "div",
                            [
                              _c("tooltips-body", {
                                attrs: {
                                  "tooltip-text": _setup.valueHint(feature),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "body",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "div",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "d-inline-block",
                                                },
                                                "div",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("v-switch", {
                                                staticClass: "pa-0 ma-0",
                                                attrs: {
                                                  color: "green darken-2",
                                                  "hide-details": "",
                                                  dense: "",
                                                },
                                                on: {
                                                  change: _setup.emitPayload,
                                                },
                                                model: {
                                                  value:
                                                    _setup.state[feature.id]
                                                      .value,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _setup.state[feature.id],
                                                      "value",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "state[feature.id].value",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "caption grey--text text--darken-1",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _setup.state[feature.id].value
                                          ? "Ligado"
                                          : "Desligado"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                      _c("div", [
                        _c("div", { staticClass: "body-2" }, [
                          _vm._v(_vm._s(feature.label)),
                        ]),
                        _c(
                          "div",
                          { staticClass: "caption grey--text text--darken-1" },
                          [_vm._v(" " + _vm._s(feature.description) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "caption mt-1 grey--text text--darken-1",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_setup.effectHint(feature)) + " "
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  color: _setup.state[
                                                    feature.id
                                                  ].locked
                                                    ? "blue darken-2"
                                                    : "grey",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _setup.toggleLock(
                                                      feature.id
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v(
                                                _vm._s(
                                                  _setup.state[feature.id]
                                                    .locked
                                                    ? "mdi-lock"
                                                    : "mdi-lock-open-variant"
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _setup.state[feature.id].locked
                                      ? "Travado: usuário não pode alterar"
                                      : "Liberado: usuário pode alterar"
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "caption grey--text text--darken-1",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _setup.state[feature.id].locked
                                      ? "Travado"
                                      : "Liberado"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                }),
              ],
              2
            ),
          ],
          1
        )
      }),
      !_setup.hasResults
        ? _c(
            "div",
            { staticClass: "text-center grey--text py-6" },
            [
              _c("v-icon", { attrs: { color: "grey lighten-1" } }, [
                _vm._v("mdi-magnify-close"),
              ]),
              _c("div", { staticClass: "caption mt-1" }, [
                _vm._v("Nenhum recurso encontrado."),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }